import { Link } from "react-router-dom";
import React, { Component } from "react";
import ReactTimeAgo from "react-time-ago";
import ReplyIcon from "@material-ui/icons/Reply";
import ScheduleIcon from "@material-ui/icons/Schedule";
import StarRateIcon from "@material-ui/icons/StarRate";
import "../../styles/css/ProjectCards/ProjectCard.css";
import StarRatingComponent from "react-star-rating-component";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import CommentIcon from "@material-ui/icons/Comment";
import API from "../../api/api";

const token = localStorage.getItem("token");
const userRole = localStorage.getItem("userRole");
const userId = localStorage.getItem("userId");

class ProjectCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: "",
      commentedUserId: "",
    };
  }
  componentDidMount() {
    // if (
    //   this.props.jobData.job_status !== "Posted" ||
    //   this.props.jobData.job_status !== "Created" ||
    //   userRole !== "Admin"
    // ) {
    //   this.getNewComment();
    // }
  }
  componentWillUnmount() {
    // clearTimeout(this.intervalID);
  }

  // async getNewComment() {
  //   await API.get(`/job/new-comments/` + this.props.jobData.id)
  //     .then((res) => {
  //       // console.log(userId);
  //       // console.log(res.data.new_comments);
  //       if (res.status === 200) {
  //         // const countMsg = res.data.new_comments.filter(
  //         //   (data) => data.user_id !== userId
  //         // ).length;
  //         // console.log(countMsg);
  //         if (res.data.new_comments.length > 0) {
  //           this.setState({
  //             count: res.data.new_comments.filter(
  //               (data) => data.user_id !== userId
  //             ).length,
  //             commentedUserId: res.data.new_comments.user_id,
  //           });
  //         }
  //       }
  //       this.intervalID = setTimeout(this.getData.bind(this), 50000);
  //     })
  //     .catch((err) => {
  //       console.log("AXIOS ERROR: ", err);
  //     });
  // }

  render() {
    const { jobData, str } = this.props;
    const timeZoneDiff = new Date().getTimezoneOffset();

    return (
      <div className="projectCardRoot">
        <Link
          to={
            userRole === "Surveyor" ||
            (userRole === "Admin" && jobData.company_name !== "admin")
              ? `/JobView/${jobData.id}`
              : userRole === "Title Company Admin" ||
                userRole === "Title Company User" ||
                userRole === "Admin"
              ? `/JobCreation/${jobData.id}`
              : `/signin`
          }
        >
          <div
            className={
              token && token.length > 0
                ? "projectCardMainLogin desktopDivFlex"
                : str === "str"
                ? "projectCardMainBrowse desktopDivFlex"
                : "projectCardMain desktopDivFlex"
            }
          >
            <div className="projectCardLeft">
              <img src="/static/images/Protractor.svg" alt="protractor" />
            </div>
            <div className="projectCardMiddle">
              <p className="projectCardTitle">{jobData.name}</p>
              <p className="projectCardDesc" id="projectCardDesc">
                {jobData.description}
              </p>
              <div className="projectCardDetails">
                {jobData.job_status === "Created" ? (
                  <div className="projectCardTime">
                    <ScheduleIcon />

                    <span>
                      Created&nbsp;
                      <ReactTimeAgo
                        date={
                          timeZoneDiff >= 0
                            ? new Date(
                                new Date(jobData.created_at.date).getTime() -
                                  timeZoneDiff * 60000
                              )
                            : new Date(
                                new Date(jobData.created_at.date).getTime() -
                                  timeZoneDiff * 60000
                              )
                        }
                      />
                    </span>
                  </div>
                ) : jobData.job_status === "Posted" ? (
                  <div className="projectCardTime">
                    {" "}
                    <ScheduleIcon />
                    <span>
                      Posted&nbsp;
                      <ReactTimeAgo
                        date={
                          timeZoneDiff >= 0
                            ? new Date(
                                new Date(
                                  jobData.posted_date + ".00000"
                                ).getTime() -
                                  timeZoneDiff * 60000
                              )
                            : new Date(
                                new Date(
                                  jobData.posted_date + ".00000"
                                ).getTime() -
                                  timeZoneDiff * 60000
                              )
                        }
                      />
                    </span>
                  </div>
                ) : jobData.new_comments.length > 0 ? (
                  <div className="projectCardTime">
                    <CommentIcon />
                    <span>
                      You have {jobData.new_comments.length} unread messages
                    </span>
                  </div>
                ) : null}

                {userRole === "Surveyor" ||
                userRole === "Admin" ||
                userRole === null ? (
                  <div className="projectCardStar">
                    <span>{jobData.company_name}</span>
                    <div className="projectCardStarRating">
                      <StarRatingComponent
                        name="rate1"
                        starCount={5}
                        value={Math.round(jobData.company_rate, 10)}
                        starColor={"#9cd5f1"}
                        emptyStarColor={"#b1b1b1"}
                        renderStarIcon={() => (
                          <StarRateIcon style={{ width: "20px" }} />
                        )}
                        editing={false}
                      />
                    </div>
                  </div>
                ) : jobData.job_status === "Created" ||
                  jobData.job_status === "Posted" ? (
                  <div className="projectCardStar bidsCount">
                    <AccountCircleIcon />
                    <div style={{ padding: "3px" }}>{jobData.bids} bid(s)</div>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="projectCardRight">
              {jobData.expire_in !== false && jobData.expire_in !== "expired" && (
                <div className="projectCardExpiresDiv">
                  <span> Bidding expires in {jobData.expire_in} day(s) </span>
                </div>
              )}
              <div className="projectCardCostDiv">
                <div className="projectCardCost">
                  <span className="projectCardCostMain">
                    ${jobData.min_bid.split(".")[0]} - $
                    {jobData.max_bid.split(".")[0]}
                  </span>
                  <span className="projectCardCostUnit">USD</span>
                </div>
                <div className="projectCardBidBtn">
                  {userRole === "Surveyor" ? (
                    !jobData.bidded ? (
                      <button>
                        <ReplyIcon className="bidBtnIcon" />
                        Bid
                      </button>
                    ) : jobData.job_status === "Posted" ? (
                      <button>Update bid</button>
                    ) : (
                      <div
                        className="jobStatus postedJobDiv"
                        style={{
                          color:
                            jobData.job_status === "Completed"
                              ? "#31c680"
                              : jobData.job_status === "Expired"
                              ? "#f79d75"
                              : "#019ae3",
                        }}
                      >
                        {jobData.job_status}
                      </div>
                    )
                  ) : userRole === null ? (
                    <button>
                      <ReplyIcon className="bidBtnIcon" />
                      Bid
                    </button>
                  ) : jobData.job_status === "Created" ? (
                    <button>
                      <ReplyIcon className="bidBtnIcon" />
                      Post
                    </button>
                  ) : (
                    <div
                      className="jobStatus postedJobDiv"
                      style={{
                        color:
                          jobData.job_status === "Completed"
                            ? "#31c680"
                            : jobData.job_status === "Expired"
                            ? "#f79d75"
                            : "#019ae3",
                      }}
                    >
                      {jobData.job_status}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div
            className={
              token && token.length > 0
                ? "projectCardMainLoginMobile mobileDiv"
                : "projectCardMainMobile mobileDiv"
            }
          >
            <div className="projectCardMiddleMobile">
              <p className="projectCardTitleMobile">{jobData.name}</p>
              <p className="projectCardDescMobile" id="projectCardDesc">
                {jobData.description}
              </p>
              <div className="projectCardDetailsMobile">
                <div className="projectCardTimeMobile">
                  <ScheduleIcon />
                  {jobData.job_status === "Created" ? (
                    <span>
                      Created&nbsp;
                      <ReactTimeAgo
                        date={
                          timeZoneDiff >= 0
                            ? new Date(
                                new Date(jobData.created_at.date).getTime() -
                                  timeZoneDiff * 60000
                              )
                            : new Date(
                                new Date(jobData.created_at.date).getTime() -
                                  timeZoneDiff * 60000
                              )
                        }
                      />
                    </span>
                  ) : (
                    <span>
                      Posted&nbsp;
                      <ReactTimeAgo
                        date={
                          timeZoneDiff >= 0
                            ? new Date(
                                new Date(
                                  jobData.posted_date + ".00000"
                                ).getTime() -
                                  timeZoneDiff * 60000
                              )
                            : new Date(
                                new Date(
                                  jobData.posted_date + ".00000"
                                ).getTime() -
                                  timeZoneDiff * 60000
                              )
                        }
                      />
                    </span>
                  )}
                </div>
                {userRole === "Surveyor" || userRole === null ? (
                  <div className="projectCardStarMobile">
                    <span>{jobData.company_name}</span>
                    <StarRatingComponent
                      name="rate1"
                      starCount={5}
                      value={Math.round(jobData.company_rate, 10)}
                      starColor={"#9cd5f1"}
                      emptyStarColor={"#b1b1b1"}
                      renderStarIcon={() => (
                        <StarRateIcon style={{ width: "20px" }} />
                      )}
                      editing={false}
                    />
                  </div>
                ) : (
                  <div className="projectCardStarMobile bidsCountMobile">
                    <AccountCircleIcon />
                    <div style={{ padding: "3px" }}>{jobData.bids} bid(s)</div>
                  </div>
                )}
                {jobData.expire_in !== false &&
                  jobData.expire_in !== "expired" && (
                    <div className="projectCardExpiresDivMobile">
                      <span>
                        {" "}
                        Bidding expires in {jobData.expire_in} day(s){" "}
                      </span>
                    </div>
                  )}
              </div>
            </div>
            <div className="projectCardRightMobile">
              <div className="projectCardCostDivMobile">
                <div className="projectCardCostMobile">
                  <span className="projectCardCostMainMobile">
                    ${jobData.min_bid.split(".")[0]} - $
                    {jobData.max_bid.split(".")[0]}
                  </span>
                  <span className="projectCardCostUnit">USD</span>
                </div>
                <div className="projectCardBidBtnMobile">
                  {userRole === "Surveyor" ? (
                    !jobData.bidded ? (
                      <button>
                        <ReplyIcon className="bidBtnIcon" />
                        Bid
                      </button>
                    ) : jobData.job_status === "Posted" ? (
                      <button>Update bid</button>
                    ) : (
                      <div
                        className="jobStatus postedJobDiv"
                        style={{
                          color:
                            jobData.job_status === "Completed"
                              ? "#31c680"
                              : jobData.job_status === "Expired"
                              ? "#f79d75"
                              : "#019ae3",
                        }}
                      >
                        {jobData.job_status}
                      </div>
                    )
                  ) : userRole === null ? (
                    <button>
                      <ReplyIcon className="bidBtnIcon" />
                      Bid
                    </button>
                  ) : jobData.job_status === "Created" ? (
                    <button>
                      <ReplyIcon className="bidBtnIcon" />
                      Post
                    </button>
                  ) : (
                    <div
                      className="jobStatus postedJobDiv"
                      style={{
                        color:
                          jobData.job_status === "Completed"
                            ? "#31c680"
                            : jobData.job_status === "Expired"
                            ? "#f79d75"
                            : "#019ae3",
                      }}
                    >
                      {jobData.job_status}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    );
  }
}

export default ProjectCard;



// WEBPACK FOOTER //
// ./src/components/ProjectCards/ProjectCard.js